import { render, staticRenderFns } from "./PscDeficiencyPreventativeMeasure.vue?vue&type=template&id=200af816&scoped=true&"
import script from "./PscDeficiencyPreventativeMeasure.vue?vue&type=script&lang=js&"
export * from "./PscDeficiencyPreventativeMeasure.vue?vue&type=script&lang=js&"
import style0 from "./PscDeficiencyPreventativeMeasure.vue?vue&type=style&index=0&id=200af816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200af816",
  null
  
)

export default component.exports